import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {TabViewCustom} from '../../../_models/tab-view-custom';
import { ListaItem } from '../../../_models/lista-item';

@Component( {
  selector: 'app-flujo-venta-consulta',
  templateUrl: 'flujo-venta-consulta.component.html'
} )

export class FlujoVentaConsultaComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listasTiposOcupaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() lisIntegraciones: ListaItem[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() titulo: string;
  tabSeleccionado = 'DATGEN';

  constructor() {
  }

  ngOnInit() {
  }

  abrirAcordeon( evento: number ) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'DATGEN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'INTEGRACIONES';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
      default: {
        break;
      }
    }
  }
}
